export default __webpack_public_path__ + "0e4457625f8ea61856c7f0b983f8ea07.png";